import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  appStatus: true,
  shopInfo: {
    shopOwner: "",
    email: "",
    shopName: "",
    myshopifyDomain: "",
  },
  listNotification: [],
  notificationsDetail: null,
});

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_APP_STATUS:
      return state
        .set("appStatus", action.status)
        .set("changeAppStatusLoading", true)
        .set("changeAppStatusResult", 0);
    case types.CHANGE_APP_STATUS_RESULT:
      return state
        .set("appStatus", action.res.status)
        .set("changeAppStatusLoading", false)
        .set("changeAppStatusResult", action.res.result);
    case types.GET_SETTINGS_RESULT:
      return state
        .set("appStatus", action.res.app_status)
        .set("dataSettings", action.res);
    case types.GET_LIST_NOTIFICATION_RESULT:
      return state.set("listNotification", fromJS(action.payload));
    case types.GET_NOTIFICATION_DETAIL_RESULT:
      return state.set("notificationsDetail", fromJS(action.payload[0]));
    default:
      return state;
  }
};

export default appReducer;
